(ns common.schema.entities.workspace.kyc.templates.capman.legal-entity-CWS
  (:require
   [common.schema.entities.workspace.kyc.templates.capman.legal-entity :as legal-entity]
   [common.schema.entities.workspace.kyc.templates.capman.CWS-config :as CWS-config]
   [potpuri.core :as p]))

(def schema
  (p/deep-merge
   legal-entity/schema
   {:kyc-template/kyc-form-preface
    CWS-config/form-preface-text
    :kyc-template/template-name
    "Legal entity - CW"

    ; Removed as per ticket DEV-5104
    #_:kyc.legal-entity/investor-categorization
    #_{:questions    {:kyc-legal-entity/professional-investor? {:default-value :no}}
       :translations {:fi "Asiakasluokittelu"}
       :info
       {:fi
        (str
         "<p>CWS:n tulee luokitella kaikki asiakkaansa. Luokittelu tapahtuu suoraan lain nojalla "
         "ja sijoituspalvelulaki sisältää yksityiskohtaiset määräykset luokitteluun vaikuttavista tekijöistä."
         "Asiakkaan luokittelulla on vaikutusta sijoittajansuojan laajuuteen sekä sovellettavaksi "
         "tuleviin menettelytapasääntöihin.</p>"
         "<p>Ammattimaisella asiakkaalla on velvollisuus ilmoittaa CWS:lle muutoksista, "
         "jotka voivat vaikuttaa asiakkaan luokitteluun. Ammattimaisella asiakkaalla on "
         "velvollisuus pyytää ei-ammattimaisen asiakkaan kohtelua, jos asiakas katsoo, "
         "ettei sillä ole riittävää kokemusta ja tietämystä arvioida palveluun tai "
         "liiketoimeen liittyviä riskejä.</p>")
        :en
        (str
         "<p>CWS should classify all of its customers. Classification takes place directly under the "
         "law and the Investment Services Act contains detailed provisions on those affecting "
         "classification factors. Customer rating has an impact on investor protection to be "
         "applied rules of procedure.</p>"
         "<p>A professional client has an obligation to report to CWS for changes that may affect "
         "customer classification. A professional client has an obligation to request the treatment "
         "of a non-professional client if the client considers that it does not have sufficient "
         "experience and knowledge to evaluate the service or risks associated with the transaction.</p>")}}}))
